<ng-container *ngIf="listOnly; else teamOptions">
    <span *ngFor="let member of team; trackBy: utils.trackByIndex" title="{{member.name}} - {{getTitleText(member)}}">
        <span *ngFor="let role of member.filteredRoles; trackBy: utils.trackByIndex" class="user-{{role}}">{{member.abbreviation}}</span>
    </span>
</ng-container>
<ng-template #teamOptions>
    <div id="team">
        <span class="label faded">Team</span>
        <div class="team">
            <div *ngFor="let member of team; let i = index; trackBy: utils.trackByIndex" fxLayout="row" fxLayoutGap="10px">
                <span><span *ngFor="let role of member.filteredRoles; trackBy: utils.trackByIndex" class="user-{{role}}">{{member.abbreviation}}</span> {{member.name}}</span>
                <!-- role dropdown -->
                <span class="dropdown role-options faded" matBadge="4" #roleDropdown [attr.data-index]="i">
                    <button 
                        type="button"
                        class="trigger" 
                        (click)="toggleRoleSelect(i)">
                        <span class="selected" [title]="getSelectedRoleText(member)" [innerHtml]="getSelectedRoleText(member)"></span>
                        <mat-icon>keyboard_arrow_down</mat-icon> 
                    </button>
                    <span class="options-panel mat-elevation-z2" [ngClass]="{'open': roleIndexOpen === i}">
                        <ul class="options">
                            <li *ngFor="let role of roles; trackBy: utils.trackByIndex">
                                <mat-checkbox [disabled]="!canEdit" [checked]="isChecked(role, member)" (change)="roleChange($event, role, member)">{{roleMap[role]}}</mat-checkbox>
                            </li>
                            <li><mat-checkbox #follower [disabled]="!canEdit" class="no-event" [checked]="getMemberRoles(member).length == 0">Follower</mat-checkbox></li>
                        </ul>
                    </span>
                </span>
                <button type="button" class="remove faded" *ngIf="canEdit" (click)="removeMember(member)"><mat-icon>remove_circle_outline</mat-icon></button>
            </div>
        </div>
        <div *ngIf="team.length == 0 && !canEdit" class="placeholder faded">No team members</div>
        <!-- member dropdown -->
        <div *ngIf="canEdit" class="dropdown user-options" #teamDropdown>
            <button 
                type="button"
                class="add-user faded trigger" 
                (click)="toggleMemberSelect()"
                [disabled]="!canEdit">
                <mat-icon class="add">add</mat-icon> 
                <input 
                    #memberSearch
                    type="search" 
                    placeholder="Add team member" 
                    [(ngModel)]="memberSearchText" 
                    (focus)="toggleMemberSelect(true)"
                    name="teamSearchInput"
                    autocomplete="teamSearchInput"
                    id="teamSearchInput{{teamSearchInput}}"
                />
            </button>
            <div class="options-panel" id="site-select" [ngClass]="{'open': panelOpen}">
                <ul class="options">
                    <li *ngFor="let option of (options | notInTeam: team) | memberSearch: memberSearchText; trackBy: utils.trackByIndex" (click)="addMember(option)">
                        <span class="user-{{option.role}}">
                            {{option.abbreviation}}
                        </span> {{option.name}}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</ng-template>